import { ISortItem } from '@root-gipro/store/interfaces'

const sortList: ISortItem[] = [
	{
		name: 'Идентификатор',
		subTitle: 'Прогнозируемые цены учитывают потенциальное изменение цен в результате сезонности и инфляции',
		sortName: 'code',
		order: true,
	},
	{
		name: 'Идентификатор',
		subTitle: 'Прогнозируемые цены учитывают потенциальное изменение цен в результате сезонности и инфляции',
		sortName: 'code',
		order: false,
	},
	{
		name: 'Наименование проекта',
		sortName: 'name',
		order: true,
		subTitle: '',
	},
	{
		name: 'Наименование проекта',
		sortName: 'name',
		order: false,
		subTitle: '',
	},
	{
		name: 'Организация',
		sortName: 'group.name',
		order: true,
		subTitle: '',
	},
	{
		name: 'Организация',
		sortName: 'group.name',
		order: false,
		subTitle: '',
	},
	{
		name: 'Дата публикации на сайте Минэнерго',
		sortName: 'publicationDate',
		order: true,
		subTitle: '',
	},
	{
		name: 'Дата публикации на сайте Минэнерго',
		sortName: 'publicationDate',
		order: false,
		subTitle: '',
	},
	{
		name: 'Год начала реализации',
		sortName: 'yearBegin',
		order: true,
		subTitle: '',
	},
	{
		name: 'Год начала реализации',
		sortName: 'yearBegin',
		order: false,
		subTitle: '',
	},
	{
		name: 'Год окончания реализации',
		sortName: 'yearEndOffer',
		order: true,
		subTitle: '',
	},
	{
		name: 'Год окончания реализации',
		sortName: 'yearEndOffer',
		order: false,
		subTitle: '',
	},
	{
		name: 'Полная сметная стоимость согласно ПСД',
		sortName: 'estimatedOfferCurrent',
		order: true,
		subTitle: '',
	},
	{
		name: 'Полная сметная стоимость согласно ПСД',
		sortName: 'estimatedOfferCurrent',
		order: false,
		subTitle: '',
	},
	{
		name: 'Оценка полной стоимости по УНЦ',
		sortName: 'valuationUncOfferForecast',
		order: true,
		subTitle: '',
	},
	{
		name: 'Оценка полной стоимости по УНЦ',
		sortName: 'valuationUncOfferForecast',
		order: false,
		subTitle: '',
	},
	{
		name: 'Оценка полной стоимости',
		sortName: 'valuationOfferForecast',
		order: true,
		subTitle: '',
	},
	{
		name: 'Оценка полной стоимости',
		sortName: 'valuationOfferForecast',
		order: false,
		subTitle: '',
	},
	{
		name: 'Остаток финансирования',
		sortName: 'balancePlanOnDisclosure',
		order: true,
		subTitle: '',
	},
	{
		name: 'Остаток финансирования',
		sortName: 'balancePlanOnDisclosure',
		order: false,
		subTitle: '',
	},
]

export default sortList
